import { type RemainingRecordingSeverity } from '@/models/recordingDuration';
import { unisonColors } from '@/theme';

const TEXT_ND_SECONDARY = '#254157';

// Shared so the minimized bar and the full screen cannot drift apart.
const remainingSeverityStyles: Record<RemainingRecordingSeverity, { color: string }> = {
  normal: { color: TEXT_ND_SECONDARY },
  warning: { color: unisonColors.onWarningContainer },
  critical: { color: unisonColors.onErrorContainer },
};

export { remainingSeverityStyles, TEXT_ND_SECONDARY };
